var render = function render(_c,_vm){return _c('div',_vm._b({class:['factlist', _vm.data.class, _vm.data.staticClass],style:(_vm.data.style),attrs:{"id":_vm.data.id}},'div',_vm.data.attrs,false),[(_vm.$slots.title)?_c('div',{staticClass:"factlist-title mb-0 pb-0"},[_c('h6',{staticClass:"font-spacing-1"},[_vm._t("title")],2)]):_vm._e(),_c('ul',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }